import ApiProps from "./apiProps";
import * as env from "./env"

export class ApiConstants {
  public api: ApiProps;

  constructor(timeout: number) {
    this.api = {
      timeout: timeout,
      baseUrl: env.REACTCORE_URL,
      coreUrl: env.CORE_URL,
      ibgeUrl: env.IBGE_URL,
      carteiraUrl: env.CARTEIRA_URL,
      campanhaUrl: env.CAMPANHA_URL
    }
  }
}

export default new ApiConstants(env.TIMEOUT);
